<template>
  <div class="chronology-main">
    <title-screen title ="4"></title-screen>
    <div v-if="tableData.length > 0">
      <div class="mt2 text-center">
        <p class="color-red">表は左右にスクロールすることができます</p>
        <el-button class="float-right" @click="editChronologyPage">家族年表を変更する</el-button>
      </div>
      <div class="mt2">
          <div  class="table-responsive table-chronology">
              <div class="table-wrap">
                <table class="el-table-cus m-0">
                    <thead>
                      <th style="min-width: 150px" class="first-column">年</th>
                      <template v-for="(data, index) in tableHeader">
                          <th :key="index" :value="index" :width="data.width">
                              {{data.header}}
                          </th>
                      </template>
                    </thead>
                    <tbody>
                      <template v-for="(data, index) in tableData">
                        <tr :key="index" :value="index">
                        <td width="150 " class="first-column">
                            <div v-if="data.type==='member'">{{data.name}}</div>
                            <div v-if="data.type==='event'" class="d-flex justify-content-center">
                                <div class="vertical-rl">{{data.name}}</div>
                            </div>
                        </td>
                          <template v-for="(value, key) in data">
                            <td :key="key" :value="key" v-if="(key !=='name' && key !== 'type')" :class="getClassCell(data, value)" class="vertical-align-top">
                              <div v-if="data.type==='member'">
                                      {{value.yearOld}}
                              </div>
                              <div v-if="data.type==='event'" class="">
                                  <table class="vertical-align-top table--border-0 table--background-0 child-table" style="width: 100%">
                                      <tr>
                                          <th v-for="(event, eIndex) in value" :key="`member_${index}_${eIndex}`">
                                              <div class="vertical-rl text-orientation-upright d-flex m-auto life-event__member-name">{{event.memberName}}</div>
                                          </th>
                                      </tr>
                                      <tr>
                                          <td v-for="(event, eIndex) in value" :key="`event_${index}_${eIndex}`" class="child-table-td">
                                              <div class="vertical-rl text-orientation-upright d-flex m-auto life-event__event-name" @click="handleClickEvent(event)">
                                                  <span v-if="event.eventUrl" style="color: #0c59cf; cursor:pointer;">{{event.eventName}}</span>
                                                  <span v-else>{{event.eventName}}</span>
                                              </div>
                                          </td>
                                      </tr>
                                  </table>
                              </div>
                            </td>
                          </template>
                          </tr>
                      </template>
                    </tbody>
                  </table>
              </div>
          </div>
      </div>
    </div>
    <div v-if="tableData.length === 0">
      <div class="mt2 text-center">
        <p class="color-red">データなし</p>
      </div>
    </div>
    <member-note :type="noteType" :gtm_class="gtmClass"></member-note>
  </div>
</template>

<script>
  import MemberMemberFamilyApi from '@/api/member-family'
  import moment from 'moment'
  import TitleScreen from '@/components/common/TitleScreen'
  import {
    INHERITANCE_OCCURS_EVENT_MASTER_KEYS,
    NOTE_TYPE
  } from '../../../../common/constance'
  import MemberNote from '@/components/common/MemberNote'

  export default {
    name: 'Chronology',
    components: {
        'title-screen': TitleScreen,
        'member-note': MemberNote
    },
    data () {
      return {
        memberFamilies: [],
        tableHeader: [],
        tableData: [],
        noteType: NOTE_TYPE.LIFE_EVENT,
        gtmClass: 'gtm_life_memo_life'
      }
    },
    methods: {
      getClassCell (data, value) {
        if (data.type === 'event') {
            return 'cell-padding-0'
        }
        if (value.hasEvent) {
            return 'cell--highlight'
        } else {
            return ''
        }
      },
      async loadData () {
          const res = await MemberMemberFamilyApi.getMemberFamilyAndChronicle()
          this.memberFamilies = res.data
          this.loadEventTable()
      },
      loadEventTable () {
        if (this.memberFamilies && this.memberFamilies.length === 0) {
          return
        }

        // Group event in year
        const listEventYear = {}
        for (const member of this.memberFamilies) {
          for (const chronology of member.myChronicleResponseDTOS) {
            let year = +moment(member.birthday).format('YYYY') + chronology.eventYear
            const event = {
              memberName: member.name,
              eventName: chronology.eventName,
              eventUrl: chronology.eventUrl
            }
            if (listEventYear[year]) {
              listEventYear[year].push(event)
            } else {
              listEventYear[year] = [event]
            }
          }
        }
        // 未来のイベントしかない場合は、今年から開始するようにする。
        const thisYear = new Date().getFullYear()
        // years without events
        const listEventYearKey = Object.keys(listEventYear)
        let minYear = Math.min(...listEventYearKey)
        if (minYear > thisYear) {
            minYear = thisYear
        }
        const maxYear = Math.max(...listEventYearKey)
        for (let year = minYear; year <= maxYear; year++) {
          if (!listEventYear[year]) {
            listEventYear[year] = ''
          }
        }

        // Make table header
        const keysSorted = Object.keys(listEventYear).sort((a, b) => +a - +b)
        const tableHeader = keysSorted.map(key => {
          const length = listEventYear[key].length
          const width = listEventYear[key].length >= 2 ? length * 25 + (length - 1) * 10 + 40 : 'auto'
          return {
            'header': key,
            'width': width
          }
        })

        // Make table data
        const tableData = []
        for (const member of this.memberFamilies) {
          const memberRow = {
            name: member.name,
            type: 'member'
          }

          for (const key of keysSorted) {
            const eventYear = key - +moment(member.birthday).format('YYYY')
            const event = member.myChronicleResponseDTOS.find(e => +e.eventYear === +eventYear)
            const yearOld = this.getYearOld(member, key)

            memberRow[key] = {
              yearOld,
              hasEvent: !!event
            }
          }

          tableData.push(memberRow)
        }

        const allEventYear = Object.assign({ 'name': 'ライフイベント', 'type': 'event' }, listEventYear)
        this.tableHeader = tableHeader
        this.tableData = [...tableData, allEventYear]
      },
      editChronologyPage () {
        this.$router.push({ name: 'editChronology' })
      },
      cellClassName (option) {
        const { row, columnIndex } = option
        if (columnIndex === 0 && row.type === 'member') {
          return
        }

        if (row.type === 'member') {
          const year = this.tableHeader[columnIndex - 1].header
          const eventYear = row[year]

          return eventYear && eventYear.hasEvent ? 'cell--highlight' : ''
        }

        if (row.type === 'event') {
          return 'vertical-align-top'
        }
      },
      getYearOld (member, year) {
        const eventYear = year - +moment(member.birthday).format('YYYY')

        if (eventYear < 0 || eventYear > 100) {
          return ''
        }

        const inheritanceOccursEvent = member.myChronicleResponseDTOS.find(e => INHERITANCE_OCCURS_EVENT_MASTER_KEYS.includes(e.eventMasterKey))
        if (inheritanceOccursEvent && eventYear > inheritanceOccursEvent.eventYear) {
          return ''
        }

        return eventYear
      },
      handleClickEvent (event) {
        if (event.eventUrl) { window.open(event.eventUrl) }
      }
    },
    created () {
      this.loadData()
    }
  }
</script>

<style scoped>
  .chronology-main {
    padding-bottom: 30px;
    word-break: normal;
  }
  .chronology-main .el-table-cus .el-table__header-wrapper {
    overflow: unset !important;
  }
  .text-right {
    text-align: right;
  }
  .title-label{
    background: #321007;
    color: #fff;
    font-size: 1.5em;
    font-weight: bold;
    padding: .5em 0;
    text-align: center;
  }
  .mt2 {
    margin-top: 2em;
  }
  .text-center {
    text-align: center;
  }
  .color-red {
    color: #a5272a;
  }
  .float-right{
    float: right;
    margin-top: -30px;
    margin-right: 5px;
  }
  @media screen and (max-width:768px) {
    .float-right{
      float: unset;
      margin-top: 10px !important;
    }
  }
  .table-chronology {
      border: 2px solid #d6d6d6;
      border-radius: 10px;
  }
  _:-ms-lang(x)::-ms-backdrop,
  .el-table-cus {
      border: 3px solid #d6d6d6;
  }
  .el-table-cus td,
  .el-table-cus th {
      border: 2px solid #d6d6d6;
  }
  .el-table-cus tr td:first-child,
  .el-table-cus th:first-child {
      border-left: unset;
  }
  .el-table-cus th {
      border-top: unset;
  }
  .el-table-cus tr td:last-child,
  .el-table-cus th:last-child {
      border-right: unset;
  }
  .el-table-cus tr:last-child td {
      border-bottom: unset;
  }
  .table-chronology .el-table-cus td .content {
      text-align: left;
  }
  .table-chronology .el-table-cus td .content img {
      width: 100%;
      height: 150px;
  }
  .table-chronology .el-table-cus .btn-delete {
      background-color: #d9534f;
      border-color: #d43f3a;
      border-radius: 5px;
      color: white;
      font-size: 18px;
      cursor: pointer;
  }
  .table-chronology .el-table-cus .note {
      margin-top: 10px;
      padding-left: 5px;
      margin-bottom: 10px;
  }
  .table-chronology .el-table-cus tr td a {
      color: #3a8ee6 !important;
  }
  .table-chronology .el-table-cus {
      width: 100%;
      margin: 1em auto;
  }
  .table-chronology .el-table-cus .bg-blue td {
      background: #8edbff;
  }
  .table-chronology .el-table-cus .bg-lightblue td {
      background: #e6f6fe;
  }
  .table-chronology .el-table-cus th {
      text-align: center;
      background-color: #f7f0df ;
      padding: 1em;
      font-size: 16px;
      font-weight: bold;
      color: #321007;
  }
  .table-chronology tr td {
      background-color: #fffdf7;
  }
  .table-chronology .el-table-cus th {
      vertical-align: middle;
  }
  .table-chronology .el-table-cus tbody tr:hover>td {
      background-color: #F5F7FA;
  }
  td.td__background--default {
      background: transparent!important;
  }
  .table-chronology td.cell--highlight {
      background-color: #ede1c5;
  }
  .table-chronology .el-table-cus td:not(.child-table-td) {
      text-align: center !important;
      font-size: 14px !important;
      color: #000000;
      padding: 1em;
      vertical-align: middle;
  }
  .table-chronology .el-table-cus th {
      text-align: center;
  }
  .table-chronology .el-table-cus td {
      text-align: center !important;
      font-size: 14px !important;
      color: #000000;
      padding: 1em;
      vertical-align: middle;
  }
  .table-chronology .table-scroll {
      overflow: hidden !important;
      position:absolute;
      top:0;
      left:0;
      pointer-events:none;
  }
  .table-scroll th, .table-scroll td {
      visibility:hidden !important;
  }
  .table-chronology .el-table-cus {
      z-index: 4;
      position: relative;
  }
  /*.table-chronology .el-table-cus .first-column {*/
  /*    left: 0;*/
  /*    position: -webkit-sticky;*/
  /*    position: sticky !important;*/
  /*    visibility:visible !important;*/
  /*    z-index: 5 !important;*/
  /*    border-right: 2px solid #d6d6d6 !important;*/
  /*}*/
  .table-chronology .el-table-cus .first-column + th,
  .table-chronology .el-table-cus .first-column + td {
        border-left: none !important;
  }
  .table-chronology tbody tr:last-child td:first-child {
      vertical-align: top !important;
  }
  .m-auto {
      margin: 0 auto;
      text-align: center !important;
      cursor: default;
  }
  .cursor-pointer {
      cursor: pointer;
  }
  _:-ms-lang(x)::-ms-backdrop,
  .table-chronology .child-table th,
  .table-chronology .child-table td {
      background-color: transparent;
  }
  _:-ms-lang(x)::-ms-backdrop,
  .table-chronology .life-event__member-name,
  .table-chronology .life-event__event-name {
      display: inline-block !important;
  }

  @supports (-webkit-touch-callout: none) {
      /* CSS specific to iOS devices */
      .m-auto:last-child{
          margin-right: 20px !important;
      }
  }
</style>
